import * as React from 'react';
import { cn } from '@/lib/utils';

// ─── 极简全局 Toast（模块级订阅，无需 Context） ─────────────────

type ToastItem = { id: number; message: string; type: 'error' | 'success' | 'info' };

type Listener = (toasts: ToastItem[]) => void;

let toasts: ToastItem[] = [];
let listeners: Listener[] = [];
let nextId = 1;

function emit() {
  for (const l of listeners) l([...toasts]);
}

export function showToast(message: string, type: ToastItem['type'] = 'info', duration = 4200) {
  const id = nextId++;
  toasts.push({ id, message, type });
  emit();
  setTimeout(() => {
    toasts = toasts.filter((t) => t.id !== id);
    emit();
  }, duration);
}

// 积分不足专用提示（语义更明确的便捷封装）
export function notifyCreditInsufficient(message: string) {
  showToast(message, 'error', 6000);
}

function subscribe(l: Listener): () => void {
  listeners.push(l);
  return () => {
    listeners = listeners.filter((x) => x !== l);
  };
}

export function ToastHost() {
  const [items, setItems] = React.useState<ToastItem[]>([]);

  React.useEffect(() => subscribe(setItems), []);

  if (items.length === 0) return null;

  return (
    <div className="pointer-events-none fixed right-4 top-4 z-[100] flex w-80 flex-col gap-2">
      {items.map((t) => (
        <div
          key={t.id}
          className={cn(
            'pointer-events-auto rounded-lg border px-4 py-3 text-sm shadow-lg',
            t.type === 'error' && 'border-destructive/50 bg-background text-destructive',
            t.type === 'success' && 'border-emerald-500/50 bg-background text-emerald-600',
            t.type === 'info' && 'border-border bg-background text-foreground'
          )}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
